'use es6';

import { Subscription, SubscriptionDefinition } from '../Records';
import { parseSubscriptionTypes, sortBy } from '../earlyRequest/sharedPreferences';
import UnsubscribeApi from '../api/UnsubscribeApi';
const processPreferencesInformationResponse = ({
  subDefs,
  portalUnsubscribed,
  preferencesGroup,
  preferencesCompanyInfo,
  email,
  brandId
}) => {
  if (subDefs.length === 0) {
    return {
      optOutAllSubscriptions: true
    };
  }
  const {
    optedInIds,
    originalIds,
    types
  } = parseSubscriptionTypes({
    portalUnsubscribed,
    subscriptions: subDefs,
    SubscriptionType: SubscriptionDefinition
  });
  return {
    brandId,
    company: {
      logoUrl: null,
      name: preferencesGroup && preferencesGroup.name || preferencesCompanyInfo && preferencesCompanyInfo.companyName || ''
    },
    email,
    hasEmail: !!email,
    validLanguages: preferencesGroup && preferencesGroup.languages,
    optedInIds,
    originalIds,
    originalOptedInIds: optedInIds,
    types: types.sort(sortBy('position'))
  };
};
const preferencesGroupService = {
  fetchPreferences: ({
    version,
    key,
    s,
    product,
    email,
    languagePreference
  }) => UnsubscribeApi.getPreferencesInformation({
    version,
    key,
    s,
    product,
    email,
    languagePreference
  }).then(processPreferencesInformationResponse),
  unsubscribeFromAll: ({
    key,
    brandId,
    originalIds
  }) => UnsubscribeApi.updatePreferencesInformation({
    key,
    brandId,
    optedInIds: [],
    originalIds
  }),
  updateSubscriptions: ({
    version,
    brandId,
    email,
    s,
    key,
    optedInIds,
    originalIds,
    product
  }) => UnsubscribeApi.updatePreferencesInformation({
    version,
    brandId,
    email,
    s,
    key,
    optedInIds,
    originalIds,
    product
  }),
  checkRedirect: ({
    key,
    version,
    product,
    email,
    s
  }) => UnsubscribeApi.checkRedirect({
    key,
    version,
    product,
    email,
    s
  })
};
const createTestPreferencesGroupService = testGroupId => ({
  fetchPreferences: ({
    key,
    languagePreference
  }) => UnsubscribeApi.getTestPreferencesInformation(key, testGroupId, languagePreference).then(processPreferencesInformationResponse),
  unsubscribeFromAll: () => Promise.resolve(),
  updateSubscriptions: () => Promise.resolve(),
  checkRedirect: () => Promise.resolve({
    shouldRedirect: false
  })
});
const legacyLinkService = {
  fetchPreferences: ({
    version,
    key,
    s,
    product,
    email,
    languagePreference
  }) => {
    // fetch subscriptions + brand information
    const subscriptionsPromise = UnsubscribeApi.getSubscriptions({
      version,
      key,
      s,
      product,
      email,
      languagePreference
    }).then(({
      portalUnsubscribed,
      subscriptions
    }) => {
      if (subscriptions.length === 0) {
        return {
          optOutAllSubscriptions: true
        };
      }
      const {
        optedInIds,
        originalIds,
        types
      } = parseSubscriptionTypes({
        portalUnsubscribed,
        subscriptions,
        SubscriptionType: Subscription
      });
      return {
        brandId: null,
        email,
        hasEmail: !!email,
        optedInIds,
        originalIds,
        originalOptedInIds: optedInIds,
        types: types.sort(sortBy('order'))
      };
    });
    const brandInfoPromise = UnsubscribeApi.getBrandInformation({
      version,
      key,
      s,
      product
    });
    return Promise.all([subscriptionsPromise, brandInfoPromise]).then(([subscriptionData, brandInfoData]) => {
      return Object.assign({}, subscriptionData, {
        company: {
          logoUrl: brandInfoData.logoUrl,
          name: brandInfoData.companyName
        }
      });
    });
  },
  unsubscribeFromAll: ({
    version,
    email,
    key,
    s,
    originalIds,
    product
  }) => UnsubscribeApi.unsubscribeFromAll({
    version,
    email,
    product,
    key,
    s,
    allSubscriptionIds: originalIds
  }),
  updateSubscriptions: ({
    version,
    key,
    s,
    email,
    optedInIds,
    originalIds,
    product
  }) => UnsubscribeApi.updateSubscriptions({
    version,
    key,
    s,
    email,
    optedInIds,
    originalIds,
    product
  }),
  checkRedirect: ({
    key,
    version,
    product,
    email,
    s
  }) => UnsubscribeApi.checkRedirect({
    key,
    version,
    product,
    email,
    s
  })
};
export const createPreferencesService = ({
  isOneToOneEmail,
  isLegacyLink,
  isTest,
  testGroupId
}) => {
  if (isLegacyLink || isOneToOneEmail) {
    return legacyLinkService;
  }
  if (isTest === 'true') {
    return createTestPreferencesGroupService(testGroupId);
  } else {
    return preferencesGroupService;
  }
};